export const programTypeToName = {
  GLOBAL_ENTRY: "Global Entry",
  SENTRI: "SENTRI",
  NEXUS: "NEXUS",
};

export const programTypeToUrlString = {
  GLOBAL_ENTRY: "global-entry",
  SENTRI: "sentri",
  NEXUS: "nexus",
};
